export const mockUserShelf = {
  "id": "friend-shelf",
  "component": {
    "id": "glue:carousel",
    "category": "carousel"
  },
  "text": {
    "title": "Friend Bops"
  },
  "children": [
    {
      "id": "friend-shelf-card0",
      "component": {
        "id": "glue2:card",
        "category": "card"
      },
      "text": {
        "title": "Just for Me",
        "subtitle": "Bopped by Shannon",
        "description": ""
      },
      "images": {
        "main": {
          "uri": "https://i.scdn.co/image/ab67616d00001e022ecf58392e391e9f6c0e02f1",
          "placeholder": "album",
          "custom": {}
        }
      },
      "target": {
        "uri": "spotify:track:6OTKVgVpVaVjhRLYizPJKA"
      },
      "custom": {
        "subtitleStyle": "metadata"
      },
      "logging": {
        "ui:group": "recently-played",
        "ui:index_in_block": 0,
        "ui:source": "05cd918cb92986-bc8d48-0319-c695-e0064012",
        "ui:uri": "spotify:playlist:37i9dQZEVXcXAAvTidcSfZ"
      },
      "metadata": {
        "sectionId": "recently-played"
      }
    },
    {
      "id": "friend-shelf-card2",
      "component": {
        "id": "glue2:card",
        "category": "card"
      },
      "text": {
        "title": "Arthur Verocai",
        "subtitle": "Bopped by Brian"
      },
      "images": {
        "main": {
          "uri": "https://i.scdn.co/image/ab67616d00001e02816dff6b953279497b0e7732",
          "placeholder": "album",
          "custom": {}
        }
      },
      "target": {
        "uri": "spotify:album:4yv17Q486G8QoqM001kFKO"
      },
      "logging": {
        "ui:group": "recently-played",
        "ui:index_in_block": 2,
        "ui:source": "05cd918cb92986-bc8d48-0319-c695-e0064012",
        "ui:uri": "spotify:album:4yv17Q486G8QoqM001kFKO"
      },
      "metadata": {
        "sectionId": "recently-played"
      }
    },
    {
      "id": "friend-shelf-card3",
      "component": {
        "id": "glue2:card",
        "category": "card"
      },
      "text": {
        "title": "Masana Temples",
        "subtitle": "Bopped by egontsb"
      },
      "images": {
        "main": {
          "uri": "https://i.scdn.co/image/ab67616d00001e02a765313b610423c0f13aa59e",
          "placeholder": "album",
          "custom": {}
        }
      },
      "target": {
        "uri": "spotify:album:5g5l9entA4bTztfpLJd1kS"
      },
      "logging": {
        "ui:group": "recently-played",
        "ui:index_in_block": 3,
        "ui:source": "05cd918cb92986-bc8d48-0319-c695-e0064012",
        "ui:uri": "spotify:album:5g5l9entA4bTztfpLJd1kS"
      },
      "metadata": {
        "sectionId": "recently-played"
      }
    },
    {
      "id": "friend-shelf-card4",
      "component": {
        "id": "glue2:card",
        "category": "card"
      },
      "text": {
        "title": "Add more friends",
        "subtitle": "Connect to follow"
      },
      "images": {
        "main": {
          "uri": "https://i.scdn.co/image/ab67706c0000bebb2ea0973e4bc01c33d270b8b0",
          "placeholder": "album",
          "custom": {}
        }
      },
      "target": {
        "uri": "spotify:superfriends:2000"
      },
      "logging": {
        "ui:group": "recently-played",
        "ui:index_in_block": 3,
        "ui:source": "05cd918cb92986-bc8d48-0319-c695-e0064012",
        "ui:uri": "spotify:album:5g5l9entA4bTztfpLJd1kS"
      },
      "metadata": {
        "sectionId": "recently-played"
      }
    },
  ],
  "custom": {
    "timestamp": [
      "1633241061754",
      "1633236666976",
      "1633236033636",
      "1633234841474",
      "1633229379062",
      "1633216626649",
      "1633044642610",
      "1633044100305",
      "1633038286328",
      "1632876696801",
      "1632680949426",
      "1632672587013",
      "1632670024504",
      "1632669837659",
      "1632605496319"
    ]
  },
  "logging": {
    "ui:group": "recently-played",
    "ui:index_in_block": 0,
    "ui:source": "05cd918cb92986-bc8d48-0319-c695-e0064012"
  },
  "metadata": {
    "sectionId": "recently-played"
  }
}
